import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rwidget-customer-account-detail-aside',
  templateUrl: './customer-account-detail-aside.component.html',
  styleUrls: ['./customer-account-detail-aside.component.scss']
})
export class CustomerAccountDetailAsideComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
